export enum BoxStatusEnum {
    CREATED = 'CREATED',
    MADE = 'MADE',
    IN_STOCK = 'IN_STOCK',
    ON_THE_MARKET = 'ON_THE_MARKET',
    ACTIVATED = 'ACTIVATED',
    PRODUCED = 'PRODUCED',
}
